import { getImageURL } from './images';
import { isBrowser, isTablet } from 'react-device-detect';

export const PAGES_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3bR0jQjS8cno4J4bDj-T_w2vGxEV8n_ihFfPW_M3nw4tFCW-NlG6u2uq17_EaBkqPNqf5oVlthvcR/pub?gid=0&single=true&output=csv';
export const IMAGES_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3bR0jQjS8cno4J4bDj-T_w2vGxEV8n_ihFfPW_M3nw4tFCW-NlG6u2uq17_EaBkqPNqf5oVlthvcR/pub?gid=513679441&single=true&output=csv';

const MIN_SCREEN_WIDTH_FOR_DESKTOP_WHY_HOW_WHAT = 768;
const MAX_SCREEN_WIDTH_FOR_DESKTOP_WHY_HOW_WHAT = 1024;

const SKIP_LINE = "---";
const SECTION_NOT_FOUND = "sectionNotFound";
const TEMPLATE_NOT_FOUND = "templateNotFound";
const YES = "yes";
const NO = "no";

export const SUMMARY_TLDR = "Summary TLDR";
export const WHAT_IS_CULTURE = "What Is Culture";
export const WHATS_NEXT = "What’s Next";
export const PURPOSE = "Purpose";
export const ACTIONS = "Actions";
export const SKILLS = "Skills";

const sections = [
  SKIP_LINE,
  SUMMARY_TLDR,
  WHAT_IS_CULTURE,
  WHATS_NEXT,
  PURPOSE,
  ACTIONS,
  SKILLS,
];

export const HEADER = "Header";
export const EMPHASIS_STATEMENT = "Emphasis Statement";
export const MINOR_STATEMENT = "Minor Statement";
export const ONE_LINE = "One Line";
export const TWO_LINE = "Two Line";
export const THREE_LINE = "Three Line";
export const FOUR_LINE = "Four Line";
export const FIVE_LINE = "Five Line";
export const QUOTE = "Quote";
export const LIST = "List";
export const ACTION_INDEX = "Action Index";
export const ACTION_ILLUSTRATION = "Action Illustration";
export const EMPHASIS_STATEMENT_IMAGE = "Emphasis Statement Image";
export const IMAGE_CAPTION_HORIZONTAL = "Image Caption Horizontal";
export const IMAGE_CAPTION_PORTRAIT = "Image Caption Portrait";
export const SECTION_ILLUSTRATION = "Section Illustration";
export const FULL_BLEED_IMAGE = "Full Bleed Image";
export const WHY_HOW_WHAT = "Why-How-What";
export const DESKTOP_WHY_HOW_WHAT = "Desktop-Why-How-What";
export const FIGURE_OUT_WHAT_YOU_WANT = "Figure Out What You Want";
export const CULTURE_STACK_EXPLAINED = "Culture Stack Explained";
export const PURPOSE_SUMMARY = "Purpose Summary";

const templates = [
  HEADER,
  SUMMARY_TLDR,
  EMPHASIS_STATEMENT,
  MINOR_STATEMENT,
  ONE_LINE,
  TWO_LINE,
  THREE_LINE,
  FOUR_LINE,
  FIVE_LINE,
  QUOTE,
  LIST,
  ACTION_INDEX,
  ACTION_ILLUSTRATION,
  EMPHASIS_STATEMENT_IMAGE,
  IMAGE_CAPTION_HORIZONTAL,
  IMAGE_CAPTION_PORTRAIT,
  SECTION_ILLUSTRATION,
  FULL_BLEED_IMAGE,
  WHY_HOW_WHAT,
  DESKTOP_WHY_HOW_WHAT,
  FIGURE_OUT_WHAT_YOU_WANT,
  CULTURE_STACK_EXPLAINED,
  PURPOSE_SUMMARY,
];

const links = {};

export function buildDataSourceFrom(rows) {
  const pages = [];
  let page = null;

  for (var i = 0; i < rows.length; i++) {
    const row = rows[i];
    const section = getSection(row);
    if (section === SKIP_LINE) {
      continue;
    }
    const template = getTemplate(row);

    let createNewPage = !page || (
      page &&
      section !== SECTION_NOT_FOUND &&
      template !== TEMPLATE_NOT_FOUND &&
      !(template === DESKTOP_WHY_HOW_WHAT && page.linesLeftToFill > 0)
    );

    if (createNewPage) {
      if (page) {
        pages.push(page);
        page = null;
      }
      page = newPage(section, template, row);
    }

    if (page.linesLeftToFill > 0) {
      page = addRowToPage(page, row);
    }

    if (page.linesLeftToFill === 0 || i === rows.length - 1) {
      page = cleanUpLinesFor(page);
      pages.push(page);
      page = null;
    }
  }

  for (i = 0; i < pages.length; i++) {
    const page = pages[i];
    if (!!page.linkTag) {
      links[page.linkTag] = i + 1;
    }
  }

  for (i = 0; i < pages.length; i++) {
    for (var j = 0; j < pages[i].lines.length; j++) {
      // replace e.g. [FirstPurposeSectionPage] with <a href='#/?p=1'>
      for (var key in links) {
        const pageNumber = links[key];
        const query = `[${key}]`;
        const anchor = `<a href="#/?p=${pageNumber}">`;
        pages[i].lines[j] = pages[i].lines[j].replace(query, anchor);
        pages[i].lines[j] = pages[i].lines[j].replace(`[/]`, `</a>`);
      }
    }

    // do the same for any list template headers and list items
    for (key in links) {
      const pageNumber = links[key];
      const query = `[${key}]`;
      const anchor = `<a href="#/?p=${pageNumber}">`;

      for (j = 0; j < pages[i].lists.length; j++) {
        pages[i].lists[j].header = pages[i].lists[j].header.replace(query, anchor);
        pages[i].lists[j].header = pages[i].lists[j].header.replace(`[/]`, `</a>`);
        for (var k = 0; k < pages[i].lists[j].lines.length; k++) {
          pages[i].lists[j].lines[k] = pages[i].lists[j].lines[k].replace(query, anchor);
          pages[i].lists[j].lines[k] = pages[i].lists[j].lines[k].replace(`[/]`, `</a>`);
        }
      }
    }
  }

  return pages;
}

export function newPage(section, template, row) {
  const error = section === SECTION_NOT_FOUND || template === TEMPLATE_NOT_FOUND;
  let errorMessage = '';
  if (error) {
    errorMessage = error === SECTION_NOT_FOUND
      ? SECTION_NOT_FOUND
      : TEMPLATE_NOT_FOUND;
  }

  const image = (isBrowser || isTablet) ? row.DesktopImageName : row.ImageName;
  const imagePosition = (isBrowser || isTablet) ? row.DesktopImagePosition : row.ImagePosition;
  const imageSize = (isBrowser || isTablet) ? row.DesktopImageSize : row.ImageSize;

  return {
    section,
    sectionSlug: section.replace(/ /g, '-').
      replace(/'/g, '').
      replace(/’/g, ''),
    template,
    templateSlug: template.replace(/ /g, '-'),
    header: null,
    footer: null,
    lists: [],
    lines: [],
    hasImageContentLine: false,
    linesLeftToFill: numLinesInTemplate(template),
    lineIndexesToIgnore: template === DESKTOP_WHY_HOW_WHAT ? [0,1,4,5,8,9] : [],
    image,
    imagePosition,
    imageSize,
    images: [{
      image,
      imagePosition,
      imageSize,
    }],
    useContentImageAsBackgroundElement: row.DesktopUseContentImageAsBackground === YES,
    linkTag: row.LinkTag,
    error,
    errorMessage,
  };
}

function addRowToPage(page, row) {
  page.header = row.Header.length > 0 ? row.Header : page.header;;
  page.footer = row.Footer.length > 0 ? row.Footer : page.footer;
  let line = row.Body;
  const lineAsImageURL = getImageURL(line);
  if (!!lineAsImageURL) {
    page.hasImageContentLine = true;
    const cssClassNames = [
      (isBrowser || isTablet) ? row.DesktopImagePosition : row.ImagePosition,
      page.useContentImageAsBackgroundElement ? 'absolute' : '',
    ];
    line = (`
      <div class="${cssClassNames.join(' ')}">
        <img src=${lineAsImageURL} width=${(isBrowser || isTablet) ? row.DesktopImageSize : row.ImageSize} />
      </div>
    `);
  } else {
    // replace [bold]x[/b] with <b></b>
    line = line.replace(/\[bold\]/g, "<b>");
    line = line.replace(/\[\/b\]/g, "</b>");

    // replace [italic]x[/i] with <i></i>
    line = line.replace(/\[italic\]/g, "<i>");
    line = line.replace(/\[\/i\]/g, "</i>");
  }

  page.images.push({
    image: (isBrowser || isTablet) ? row.DesktopImageName : row.ImageName,
    imagePosition: (isBrowser || isTablet) ? row.DesktopImagePosition : row.ImagePosition,
    imageSize: (isBrowser || isTablet) ? row.DesktopImageSize : row.ImageSize,
  });

  if (page.template === LIST) {
    if (row.Header !== "") {
      page.lists.push({ header: row.Header, lines: [] });
    } else {
      page.lists[page.lists.length - 1].lines.push(line);
    }
  } else {
    page.lines.push(line);
    page.linesLeftToFill--;
  }

  return page;
}

function getSection(row) {
  const idx = sections.indexOf(row.Section);
  if (idx === -1) {
    return SECTION_NOT_FOUND;
  }

  return row.Section;
}

function cleanUpLinesFor(page) {
  if (page.template === DESKTOP_WHY_HOW_WHAT && page.lineIndexesToIgnore.length > 0) {
    page.lines = page.lines.filter((line, i) => {
      return !page.lineIndexesToIgnore.includes(i);
    });
    page.images = page.images.filter((line, i) => {
      return !page.lineIndexesToIgnore.includes(i);
    });
  }
  return page;
}

function getTemplate(row) {
  const idx = templates.indexOf(row.Template);
  if (idx === -1) {
    return TEMPLATE_NOT_FOUND;
  }

  if (isBrowser && !isTabletWhyHowWhat() && row.Template === WHY_HOW_WHAT) {
    row.Template = DESKTOP_WHY_HOW_WHAT;
  }

  return row.Template;
}

// gross:
// https://trello.com/c/UW5vJM1U/163-priority-768-x-1024-why-how-what
function isTabletWhyHowWhat() {
  return (
    window.innerWidth >= MIN_SCREEN_WIDTH_FOR_DESKTOP_WHY_HOW_WHAT &&
    window.innerWidth < MAX_SCREEN_WIDTH_FOR_DESKTOP_WHY_HOW_WHAT
  );
}

function numLinesInTemplate(template) {
  switch (template) {
    case DESKTOP_WHY_HOW_WHAT:
      return 12;
    case FIVE_LINE:
      return 5;
    case FOUR_LINE:
      return 4;
    case THREE_LINE:
      return 3;
    case TWO_LINE:
    case QUOTE:
    case FIGURE_OUT_WHAT_YOU_WANT:
    case WHY_HOW_WHAT:
    case CULTURE_STACK_EXPLAINED:
      return 2;
    case LIST:
    case ACTION_INDEX:
      return 99999;
    default:
      return 1;
  }
}

export function getURLForNavKey(key) {
  if (key in links) {
    const pageNumber = links[key];
    return `#/?p=${pageNumber}`
  }

  // NOTE should all be wired up to a navigation google sheet
  if (key === 'view-the-skills-matrix') {
    return 'https://docs.google.com/spreadsheets/d/1hn-B6FJApHdkU7FJlC6OyNxqCVWPC8EMWI7aTYbRLF4/edit?usp=sharing'
  }

  return "#/?p=1";
}

export function templateRendersAllLinesByDefault(template) {
  const templatesThatRenderAllLinesByDefault = [
    QUOTE,
    FIGURE_OUT_WHAT_YOU_WANT,
    WHY_HOW_WHAT,
    CULTURE_STACK_EXPLAINED,
    LIST,
    ACTION_INDEX,
  ];

  return templatesThatRenderAllLinesByDefault.includes(template);
}
